/**
 * Full-page navigation, behind a function.
 *
 * Exists for one reason: `window.location.assign` cannot be intercepted in a
 * test. jsdom defines `location` as unforgeable, so it can be neither replaced
 * nor spied on, and calling it just logs "Not implemented: navigation". Routing
 * every hand-off to another origin through here gives tests a seam to mock
 * without the production code changing shape.
 *
 * For in-app navigation use React Router. This is for leaving the app — e.g. the
 * Advisory login's redirect to Common Services.
 *
 * @param {string} url
 */
export function redirectTo(url) {
  window.location.assign(url);
}
